var $3a706ba61f3d6bba$exports = {};
$3a706ba61f3d6bba$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe1lasszon ki egy elemet`,
    "tableResizer": `\xc1tm\xe9retez\u{151}`,
    "colorSwatchPicker": `Color swatches`
};


export {$3a706ba61f3d6bba$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
